// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyBvnj6SDdvvz0jlCfBfNTbKP4g9pGmsxbs",
  authDomain: "challenge-ce4d1.firebaseapp.com",
  projectId: "challenge-ce4d1",
  storageBucket: "challenge-ce4d1.appspot.com",
  messagingSenderId: "89944747070",
  appId: "1:89944747070:web:6537bde0b39909ec65b56f",
  measurementId: "G-RTESDRZ9Y9",
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
export { db, auth };
